<template>
  <div v-if="screenData" class="view tv dark">
    <Screen :data="tv1Screen3">
      <template #header>
        <HeaderBlock>
          <TransportList :current-filter="screenData.currentTransportFilter" />
          <Baseline :data="header.baseline" />
        </HeaderBlock>
      </template>
      <TableBlock :data="tv1Screen3.data" :index="index" />
    </Screen>
    <Screen :data="tv2Screen3">
      <TableBlock :data="tv2Screen3.data" :index="index" />
    </Screen>
    <Screen :data="tv3Screen3">
      <TableBlock :data="tv3Screen3.data" :index="index" />
    </Screen>
    <Screen :data="impactTv4">
      <Proportion class="dark tv" :data="screenData" :index="index" />
    </Screen>
  </div>
</template>

<script>
import Tv from './TvMixin';
import Proportion from '@/components/Analysis/Impact/Proportion';
import { extendedTimeRangesCaptions, timeRangesCaptions } from '@/pure/ComputedData';

export default {
  components: {
    Proportion,
  },

  mixins: [Tv],

  data() {
    return {
      state: '',
      lastState: '',
      distribution: '',
      index: -1,
      screenData: null,
    };
  },

  computed: {
    header() {
      const { averageTime } = this.screenData;
      return {
        baseline: {
          value: averageTime,
          sub: ' min',
          caption: `${this.$t('averageTimeByCurrentSite')} :`,
        },
      };
    },

    tv1Screen3() {
      const { filteredCollaboratorsCount, sites } = this.screenData;
      const value = filteredCollaboratorsCount;
      return {
        heading: {
          caption: this.$t('improvements'),
          icon: 'happy',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
        data: {
          specifications: [
            {
              className: {
                big: true,
              },
            },
            {
              type: 'heading',
              caption: `${this.$t('collaboratorsNumber')} :`,
            },
            {
              type: 'heading',
              caption: `${this.$t('averageTimeSaved')} :`,
            },
          ],
          entries: this.computeImpact(sites, 'improvement'),
        },
      };
    },

    tv2Screen3() {
      const { filteredCollaboratorsCount, sites } = this.screenData;
      const value = filteredCollaboratorsCount;
      return {
        heading: {
          caption: this.$t('degradations'),
          icon: 'sad',
          baseline: {
            value,
            caption: `${this.$t('collaboratorCount')} :`,
          },
        },
        data: {
          specifications: [
            {
              type: 'heading',
              caption: `${this.$t('collaboratorsNumber')} :`,
            },
            {
              type: 'heading',
              caption: `${this.$t('averageAdditionalTime')} :`,
            },
          ],
          entries: this.computeImpact(sites, 'decay', true),
        },
      };
    },

    tv3Screen3() {
      const { sites, useExtendedTimeRanges } = this.screenData;
      const headerCaption = useExtendedTimeRanges ? extendedTimeRangesCaptions : timeRangesCaptions;
      const entries = sites.map(site => {
        const { decayedCollaboratorsTimesByTimeRanges } = site.details;
        return decayedCollaboratorsTimesByTimeRanges.map(item => {
          return {
            value: item.count,
          };
        });
      });
      return {
        heading: {
          caption: this.$t('report.impactFocus'),
          icon: 'sad',
        },
        data: {
          specifications: headerCaption.map(caption => {
            return {
              type: 'heading',
              caption,
              icon: 'up',
            };
          }),
          entries,
        },
      };
    },

    impactTv4() {
      return {
        heading: {
          caption: this.$t('sections.impact'),
          icon: 'happy',
        },
      };
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudyResult', { id }).then(() => {
      this.screenData = this.$store.getters.screen();
    });
  },
};
</script>
